import React, { FC } from 'react';
import round from 'lodash.round';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';
import { currencySymbol } from '../../../AddNewPositionWizard/components/BillingStep';

const { FormattedMessage, injectIntl } = Intl;

interface BillingSectionProps extends Intl.InjectedIntlProps {
  data: Resources.MatchBilling;
}

const BillingSection: FC<BillingSectionProps> = props => {
  const { intl, data } = props;
  const { billRate, estimatedSpend } = data;

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.matchRecord.billing.title} />
          </H3>
        }
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.billing.billRate}
            />
          }
          type={CardInfoValueType.Text}
          value={
            billRate ? `${currencySymbol(intl)}${round(billRate, 2)}` : '-'
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.billing.estimatedSpend}
            />
          }
          type={CardInfoValueType.Text}
          value={
            estimatedSpend
              ? `${currencySymbol(intl)}${round(estimatedSpend, 2)}`
              : '-'
          }
        />
      </CardInfo>
    </FlexItem>
  );
};

export default injectIntl(BillingSection);
